// Layout constants + pure helpers for the Timeline ribbon.
export const PX_PER_YEAR = 2.4;
export const CARD_W = 176;
export const CARD_H = 52;
export const ROW_GAP = 8;
export const PAD = 120;

export const eraLabel = (y) => (y < 0 ? `${Math.abs(y)} BCE` : `${y} CE`);

// Greedy row-packing so cards near the same year stack instead of overlapping.
export function packLane(items, minYear) {
  const rowEnds = [];
  return items.map((it) => {
    const x = PAD + (it.year - minYear) * PX_PER_YEAR;
    let r = 0;
    while (r < rowEnds.length && rowEnds[r] > x - 6) r += 1;
    rowEnds[r] = x + CARD_W;
    return { ...it, x, row: r };
  });
}

// Derive everything the ribbon needs to render from the raw timeline payload.
export function buildTimelineLayout(data) {
  if (!data?.items?.length) {
    return { texts: [], persons: [], totalW: 0, ticks: [], textLaneH: 0, personLaneH: 0 };
  }
  const { min, max } = data.range;
  const texts = packLane(data.items.filter((i) => i.type === "text"), min);
  const persons = packLane(data.items.filter((i) => i.type === "person"), min);
  const totalW = PAD * 2 + (max - min) * PX_PER_YEAR;

  const step = 250; // era ticks every 250 years, aligned to round numbers
  const ticks = [];
  for (let y = Math.ceil(min / step) * step; y <= max; y += step) {
    ticks.push({ y, x: PAD + (y - min) * PX_PER_YEAR });
  }
  const textRows = texts.reduce((m, i) => Math.max(m, i.row), 0) + 1;
  const personRows = persons.reduce((m, i) => Math.max(m, i.row), 0) + 1;
  return {
    texts,
    persons,
    totalW,
    ticks,
    textLaneH: textRows * (CARD_H + ROW_GAP) + 12,
    personLaneH: personRows * (CARD_H + ROW_GAP) + 12,
  };
}
